<template lang="pug">
div
  .columns.is-mobile-.has-text-centered
    .column
      ToggleButton(
        v-model="firmarConTableta" 
        :labels="{checked: 'Tableta', unchecked: 'Normal'}"
        :color="{checked: '#53565A', unchecked: '#C8102E'}"
        :width="configButton.width"
        :height="configButton.height"
        :font-size="configButton.fontSize"
      )
  .columns.is-mobile.has-text-centered(v-show="!firmarConTableta")
    .column.is-12
      VueSignaturePad#signature(
        width="250px",
        height="250px",
        ref="signaturePad",
        :options="options",
        v-show="isShow"
        name="cnv"
      )
  .columns.has-text-centered(v-show="!firmarConTableta")
    .column.is-12
      a.button.is-dark.is-rounded(@click="resetCanvas") Limpiar
      | &nbsp
      a.button.is-primary.is-rounded(@click="saveFirma") Firmar
  .columns.is-mobile.has-text-centered(v-show="firmarConTableta")
    .column.is-12
      canvas#cnv(name="cnv" width="500" height="100" :class="firmarConTableta ? 'display: block;': 'display: none;'")
  .columns.has-text-centered(v-show="firmarConTableta")
    .column.is-12
      a.button.is-rounded.is-black(@click="onSign") Firmar
      | &nbsp
      a.button.is-rounded.is-light(@click="onClear") Limpiar
      | &nbsp
      a.button.is-rounded.is-dark(@click="onDone") Terminar
</template>

<script>
import * as sigWeb from '@nn-afly/topaz-sig-web'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  name: "Signature",
  components: { ToggleButton },
  data() {
    return {
      options: {
        penColor: "#020ca2",
      },
      file: "",
      isShow: false,
      isConnectedSigWebTablet: true,
      tmr: null,
      ctx: null,
      getSigString: null,
      sigImageData: null,
      firmarConTableta: false,
      configButton: {
        width: 85,
        height: 30,
        fontSize: 14,
      }
    }
  },
  methods: {
    iniciarcomponente() {
      console.log(sigWeb)
      this.isConnectedSigWebTablet = sigWeb.IsSigWebInstalled()
      //this.firmarConTableta = this.isConnectedSigWebTablet 
      console.log(this.isConnectedSigWebTablet)
      this.$emit('sigWebStatus', this.isConnectedSigWebTablet)
      this.showWithResize()
    },

    resetCanvas() {
      console.log(this.$refs.signaturePad)
      this.$refs.signaturePad.undoSignature()
    },

    saveFirma() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      if (isEmpty) {
        this.file = "NoData"
      } else {
        this.file = data
      }
      this.$emit("saveFile", this.file)
    },

    showWithResize() {
      console.log('Resize')
      this.isShow = true
      this.$refs.signaturePad.$refs.signaturePadCanvas.width = 250
      this.$refs.signaturePad.$refs.signaturePadCanvas.height = 250
    },

    closingSigWeb() {
      sigWeb.ClearTablet()
      sigWeb.SetTabletState(0, this.tmr)
    },

    onClear() {
      sigWeb.ClearTablet()
    },

    onSign() {
      this.ctx = document.getElementById('cnv').getContext('2d')
      sigWeb.SetDisplayXSize(500)
      sigWeb.SetDisplayYSize(100)
      sigWeb.SetTabletState(0, this.tmr)
      sigWeb.SetJustifyMode(0)
      if (this.tmr == null) {
        this.tmr = sigWeb.SetTabletState(1, this.ctx, 50)
      } else {
        sigWeb.SetTabletState(0, this.tmr)
        this.tmr = null
        this.tmr = sigWeb.SetTabletState(1, this.ctx, 50)
      }
    },

    onDone() {
      console.log('onDone')
      if (sigWeb.NumberOfTabletPoints() == 0) {
        this.saveFirmaFromTablet()
        console.log('Debe firmar antes de continuar')
      } else {
        console.log(this.ctx)
        sigWeb.SetTabletState(0, this.tmr)
        const stringImagen = sigWeb.GetSigString()
        //const stringImagen = '01008A00D803510000FF01FF01FE01FE01FD01FE00FEFFFE00FEFEFEFD00FA00F901F603F404F205F007EF08EF09EF0AF00AF00CF10CF30EF40EF60EF70EF90EFB0EFC0CFF0C000B030A040808070A050D010FFF12FB13F715F415F015EE16EB15EA14EA12EB10ED0EEF0BF009F205F504F701F8FFFBFEFCFDFDFCFFFA01F803F605F407F209F10CF00EF00FF010F111F310F50FF80EFA0DFD0BFF0A000803070405060308010BFE0EFB10F912F614F314F114F012F111F30DF50BF609F906FB04FC02FE00000000FE01FC03FA06F707F609F50BF40CF50DF60DF60DF70DF70CF90CF90BFC09FC09FF07000603040403060209FF0BFE0DFD0FFB10FB11FB11FC0FFC0DFE0BFD08FF05FF04FF0100010001000000000101000000'
        console.log(stringImagen)
        this.getSigString = stringImagen
        sigWeb.SetSigCompressionMode(1)

        sigWeb.SetImageXSize(500)
        sigWeb.SetImageYSize(100)
        sigWeb.SetImagePenWidth(5)
        sigWeb.GetSigImageB64(this.SigImageCallback)
      }
    },

    SigImageCallback(str) {
      this.sigImageData = str
      this.saveFirmaFromTablet()
    },

    saveFirmaFromTablet() {
      //const strFake = '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'
      //const imageFromTablet = `data:image/png;base64,${strFake}`
      const imageFromTablet = `data:image/png;base64,${this.sigImageData}`
      this.$emit("saveFile", imageFromTablet)
    },

  },
  mounted () {
    console.log(`Mounted: isShow: ${this.isShow}`)
    this.iniciarcomponente()
  },
  destroyed () {
    this.closingSigWeb()
  },
}
</script>

<style lang="css" scoped>
  #signature {
    border: 2px solid #00d1b2;
    cursor: crosshair;
    border-radius: 5%;
    margin: 0 auto;
  }
  canvas {
    position: relative;
    border: 2px solid #00d1b2;
    cursor: crosshair;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/Signature.vue